import {observer} from 'mobx-react';
import {t, withState} from 'shared/core';
import {FormattedMessage} from 'react-intl';
import {Label} from 'shared/components';
import TypePolicyModalState from '../state/TypePolicyModalState';

const DetailRow = observer(({title, value, className = 'jumbo'}) => {
  return (
    <div className='clearfix my2'>
      <div className='col col-6'>
        {title}
      </div>
      <div className={`col col-6 ${className}`}>
        <Label model={value} />
      </div>
    </div>
  );
});

const UnlimitedPolicySummaryModalContent = observer(({uiState}) => {
  const {typePolicy, policySummaryAccount} = uiState;
  const {timeOffType} = policySummaryAccount;

  return (
    <div>
      <div className='h2 medium'>
        <FormattedMessage id='employees.profile.time_off.POLICY' values={{policy: timeOffType.name}}/>
      </div>
      <DetailRow
        title={t('employees.profile.time_off.Total Days/Year')} className='black medium'
        value={policySummaryAccount.unlimited ?
          t('employees.profile.time_off.Flexible') :
          t('employees.profile.time_off.DAYS', {days: policySummaryAccount.balanceView})
        }
      />
      <DetailRow
        title={t('employees.profile.time_off.Waiting Period')} className='black medium'
        value={t('employees.profile.time_off.DAYS', {days: typePolicy.waitPeriod})}/>
      <hr/>
      <div className='h3 medium mb2'>
        <FormattedMessage id='employees.profile.time_off.Additional Details'/>
      </div>
      <FormattedMessage id='employees.profile.time_off.This policy does not accrue a balance, but you can still request time off.'/>
    </div>
  );
});

export default withState(UnlimitedPolicySummaryModalContent, TypePolicyModalState);
